import { Suspense, lazy } from "react";
import { useSprint26FlagVisible } from "../lib/featureFlags.js";
import { useIsMobile } from "./useIsMobile.js";

/**
 * E-BUNDLE-19 — Ladeschranke vor dem PWA-Hinweis.
 *
 * `PwaInstallHint` erscheint nur auf schmalen Viewports und nur, solange das
 * Flag `sprint26.mobilePwaPolish` sichtbar ist. Das Flag kommt aus einem
 * Netz-Roundtrip, also ist der Hinweis beim ersten Paint immer unsichtbar —
 * auf Desktop dauerhaft. Der Chunk lag dennoch im Startpfad.
 *
 * Die Schranke prueft die beiden billigen Vorbedingungen (Flag und Viewport)
 * und laedt das Modul erst dann. Die Entwarnung per `localStorage` bleibt in
 * der Komponente: sie ist per Browser verschieden, und ein einmal geladener
 * Chunk kostet den entwarnten Nutzer nichts mehr.
 */
const PwaInstallHint = lazy(async () => {
  const mod = await import("./PwaInstallHint.js");
  return { default: mod.PwaInstallHint };
});

export function PwaInstallHintGate() {
  const { visible } = useSprint26FlagVisible("sprint26.mobilePwaPolish");
  const isMobile = useIsMobile();
  if (!visible || !isMobile) return null;
  return (
    <Suspense fallback={null}>
      <PwaInstallHint />
    </Suspense>
  );
}
